#import './TravelersFields.graphql'
query Travelers(
  $first: Int
  $after: Cursor
  $filter: TravelerFilter
  $orderBy: [TravelersOrderBy!]
) {
  travelers(first: $first, after: $after, filter: $filter, orderBy: $orderBy) {
    nodes {
      ...TravelersFields
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
